/**
 * @fileoverview gRPC-Web generated client stub for CategoryPredict
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.8.0
// source: categoryPredictService.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.CategoryPredict = require('./categoryPredictService_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.CategoryPredict.CategoryPredictServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryQuotaRequest,
 *   !proto.CategoryPredict.CategoryQuotaResponse>}
 */
const methodDescriptor_CategoryPredictService_getQuota = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/getQuota',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryQuotaRequest,
  proto.CategoryPredict.CategoryQuotaResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryQuotaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryQuotaResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryQuotaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryQuotaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryQuotaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.getQuota =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/getQuota',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_getQuota,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryQuotaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryQuotaResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.getQuota =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/getQuota',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_getQuota);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryUploadRequest,
 *   !proto.CategoryPredict.CategoryUploadResponse>}
 */
const methodDescriptor_CategoryPredictService_uploadPreview = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/uploadPreview',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryUploadRequest,
  proto.CategoryPredict.CategoryUploadResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryUploadResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.uploadPreview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/uploadPreview',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_uploadPreview,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryUploadResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.uploadPreview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/uploadPreview',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_uploadPreview);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryCreateTaskRequest,
 *   !proto.CategoryPredict.CategoryTaskResponse>}
 */
const methodDescriptor_CategoryPredictService_createTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/createTask',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryCreateTaskRequest,
  proto.CategoryPredict.CategoryTaskResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryTaskResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.createTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/createTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_createTask,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryCreateTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryTaskResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.createTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/createTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_createTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskPageRequest,
 *   !proto.CategoryPredict.CategoryTaskPageResponse>}
 */
const methodDescriptor_CategoryPredictService_pageTasks = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/pageTasks',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskPageRequest,
  proto.CategoryPredict.CategoryTaskPageResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryTaskPageResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryTaskPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryTaskPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.pageTasks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pageTasks',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pageTasks,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryTaskPageResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.pageTasks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pageTasks',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pageTasks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRequest,
 *   !proto.CategoryPredict.CategoryTaskResponse>}
 */
const methodDescriptor_CategoryPredictService_getTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/getTask',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskRequest,
  proto.CategoryPredict.CategoryTaskResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryTaskResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.getTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/getTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_getTask,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryTaskResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.getTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/getTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_getTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRowsRequest,
 *   !proto.CategoryPredict.CategoryTaskRowsResponse>}
 */
const methodDescriptor_CategoryPredictService_pageTaskRows = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/pageTaskRows',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskRowsRequest,
  proto.CategoryPredict.CategoryTaskRowsResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryTaskRowsResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryTaskRowsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryTaskRowsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.pageTaskRows =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pageTaskRows',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pageTaskRows,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRowsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryTaskRowsResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.pageTaskRows =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pageTaskRows',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pageTaskRows);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRequest,
 *   !proto.CategoryPredict.CategoryOperationResponse>}
 */
const methodDescriptor_CategoryPredictService_pauseTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/pauseTask',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskRequest,
  proto.CategoryPredict.CategoryOperationResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryOperationResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.pauseTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pauseTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pauseTask,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryOperationResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.pauseTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/pauseTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_pauseTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRequest,
 *   !proto.CategoryPredict.CategoryOperationResponse>}
 */
const methodDescriptor_CategoryPredictService_resumeTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/resumeTask',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskRequest,
  proto.CategoryPredict.CategoryOperationResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryOperationResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.resumeTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/resumeTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_resumeTask,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryOperationResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.resumeTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/resumeTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_resumeTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRequest,
 *   !proto.CategoryPredict.CategoryOperationResponse>}
 */
const methodDescriptor_CategoryPredictService_cancelTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/cancelTask',
  grpc.web.MethodType.UNARY,
  proto.CategoryPredict.CategoryTaskRequest,
  proto.CategoryPredict.CategoryOperationResponse,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryOperationResponse.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.CategoryPredict.CategoryOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.cancelTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/cancelTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_cancelTask,
      callback);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.CategoryPredict.CategoryOperationResponse>}
 *     Promise that resolves to the response
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.cancelTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/cancelTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_cancelTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.CategoryPredict.CategoryTaskRequest,
 *   !proto.CategoryPredict.CategoryExportChunk>}
 */
const methodDescriptor_CategoryPredictService_exportTask = new grpc.web.MethodDescriptor(
  '/CategoryPredict.CategoryPredictService/exportTask',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.CategoryPredict.CategoryTaskRequest,
  proto.CategoryPredict.CategoryExportChunk,
  /**
   * @param {!proto.CategoryPredict.CategoryTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.CategoryPredict.CategoryExportChunk.deserializeBinary
);


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryExportChunk>}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServiceClient.prototype.exportTask =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/exportTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_exportTask);
};


/**
 * @param {!proto.CategoryPredict.CategoryTaskRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.CategoryPredict.CategoryExportChunk>}
 *     The XHR Node Readable Stream
 */
proto.CategoryPredict.CategoryPredictServicePromiseClient.prototype.exportTask =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/CategoryPredict.CategoryPredictService/exportTask',
      request,
      metadata || {},
      methodDescriptor_CategoryPredictService_exportTask);
};


module.exports = proto.CategoryPredict;

